<ng-container *ngIf="action === 'enrollmentUsers'">
	<app-form-view [popup]="'true'" [button]="{caption: locale.translate('enroll_users'), icon: 'add_circle'}"
		(action)="addUsers($event,'addEnrollUsers')">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="manage-course-listing" fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event)"
							#tab>
							<mat-tab [label]="locale.translate('active')">
								<ng-container *ngIf="tabIndex === 0">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('completed')">
								<ng-container *ngIf="tabIndex === 1">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>

</ng-container>

<ng-container *ngIf="['addCourse', 'editCourse'].includes(action)">
	<app-form-view [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-course-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="10px" fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData"
											[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="skillField?.length">
											<div class="block-title"> {{ locale.translate('skills_covered') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="skillField" [formObjectData]="formObjectData"
												[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="0px"
												fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</div>

									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="preRequisiteField?.length">
											<div class="block-title"> {{ locale.translate('prerequisites_skills') }}
											</div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="preRequisiteField"
												[formObjectData]="formObjectData" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
												(formObject)="formObjectReader($event)">
											</app-form-group>
										</div>
									</div>

									<ng-container *ngIf="this.action === 'addCourse'">
										<app-collapsible-area [data]="{title: locale.translate('publish')}"
											[toggle]="{expanded: true, showToggle: true}" color="#fff">
											<div class="visibility-content-area" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="10px">
												<span class="visibility-desc">
													{{locale.translate('select_channels_to_publish_if_not_published_desc')}}
												</span>
												<div fxLayout fxLayoutAlign="center start" class="form-container">
													<app-form-group [fieldList]="visibilityField" [formObjectData]="formObjectData"
														[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
														fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
														(formObject)="formObjectReader($event)">
													</app-form-group>
												</div>
											</div>
										</app-collapsible-area>
									</ng-container>

									<app-alert id="courseAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
										fxLayoutGap="10px">
										<ng-container *ngIf="action === 'addCourse'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('save')}}</button>

											<!-- <button [disabled]="submitDisable" (click)="submit('publish')" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('publish')}}</button> -->
										</ng-container>
										<ng-container *ngIf="action === 'editCourse'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('update')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
											class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-template #list let-data="data">
	<div class="enrollment-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="6px">
		<div class="enrollment-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="34px">
			<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.xs="column"
				fxLayoutAlign.xs="start stretch">
				<div fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch">
					<ng-container *ngIf="users.length === 0 && !loader && !controlValue">
						<div class="no-data" fxLayoutAlign="center center">
							<p>
								{{locale.translate('no_enrollments_yet')}}
							</p>
						</div>
					</ng-container>
					<ng-container *ngIf="users.length || (!users.length && controlValue)">
						<div class="search-form" fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1"
							fxFlex.xs="auto">
							<div fxLayout="row" fxLayoutAlign="start stretch" fxFlex="1 1" fxFlex.xs="auto"
								#formElement>
								<app-form-group [fieldList]="formFields" [config]="config"
									(formObject)="formObjectReader($event)" (search)="searched()" (clear)="clear()">
								</app-form-group>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="enrollment-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<loader [loader]="loader" [type]="'general'"></loader>
				<ng-container *ngIf="users.length === 0 && !loader && controlValue">
					<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
						<p>
							{{locale.translate('nothing_to_show')}}
						</p>
					</div>
				</ng-container>
				<ng-container *ngIf="users?.length">
					<app-common-list [layout]="'column'" [layoutGap]="'20px'" [count]="usersCount" [pageSize]="limit"
						type="pagination" (pagination)="pagination($event)">

						<list-item *ngFor="let user of users; trackBy: gfService.trackByID.bind({'key': 'userID'})">
							<content-area class="enrollment-item" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="24px">
								<!-- <app-chips type="legend" (title)="searchPeopleDetail(user)"
									[data]="{imageSrc: user?.profilePicURL, title: user.name, shortInfo: user?.shortInfo}">
								</app-chips> -->
								<app-profile-list-card [record]="user" [completionDate]="completionDate"
									(click)="courseProgressDetail(user)">
								</app-profile-list-card>
								<!-- <div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
									(click)="courseProgressDetail(user)">
									<div class="user-pic" fxFlex="0 0 40px">
										<ng-container *ngIf="![null, undefined, ''].includes(user?.profilePicURL)">
											<img [src]="user?.profilePicURL"
												(error)="gfService.setErrorImage($event, 'man')">
										</ng-container>
										<ng-container *ngIf="[null, undefined, ''].includes(user?.profilePicURL)">
											<img src="assets/img/man.png">
										</ng-container>
									</div>
									<div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
										fxLayoutAlign="start stretch" fxLayoutGap="4px">
										<div class="user-details" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="0px">
											<span class="entity-title linkable">{{user.name}}</span>

											<div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
												<ng-container *ngFor="let data of user?.shortInfo; let isLast = last">
													<span class="sub-text-1">{{data.value}}</span>
													<ng-container *ngIf="!isLast">
														<span>|</span>
													</ng-container>
												</ng-container>
											</div>
										</div>
										<div class="overfiew" fxLayout="row" fxLayoutAlign="start center"
											fxLayoutGap="10px">
											<span class="date-item">{{user?.date}}</span>
											<div fxFlex="0 1 20%" fxFlex.xs="auto" fxLayoutAlign="start center">
												<mat-progress-bar class="progress-br" color="primary" mode="determinate"
													value="40">
												</mat-progress-bar>
											</div>
										</div>
									</div>
								</div> -->
							</content-area>
						</list-item>
					</app-common-list>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="action === 'moderate' || action === 'addEnrollUsers'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{ title }}
		</form-title>
		<content-area>
			<div class="add-course-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text" [innerHtml]="info | safeDom" #infoTextEl>
									<!-- {{info}} -->
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="10px" fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData"
											[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)">
										</app-form-group>
									</div>
									<app-alert id="manageForm"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
										fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
											class="submit-btn" type="button">
											<ng-container *ngIf="action === 'moderate'">
												{{locale.translate('submit')}}
											</ng-container>
											<ng-container *ngIf="action === 'addEnrollUsers'">
												{{locale.translate('enroll')}}
											</ng-container>
										</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
											class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>


<ng-container *ngIf="['addModule', 'editModule', 'addActivity', 'nominate', 'enrollCourse'].includes(action)">
	<app-form-view [popup]="formPopup">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-course-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100"
								fxLayoutGap="10px" fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData"
											[config]="config" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<ng-container *ngIf="(resourceField?.length && action === 'addActivity') && !(selectedContentType?.key==='scorm'&& selectedResources.length>0)">
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="resourceField"
												[formObjectData]="formObjectData" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column"
												fxLayoutAlign.xs="start stretch"
												(formObject)="formObjectReader($event)"></app-form-group>
										</div>
										<ng-container
											*ngIf="['learningContent', 'events', 'moocs', 'scorm'].includes(selectedContentType?.key) && showNewResource">
											<div class="card-title" fxLayout="row" fxLayoutAlign="start center"
												fxLayoutGap="5px">
												<p class="hyperlink" (click)="addResource()">
													<ng-container
														*ngIf="selectedContentType?.key === 'learningContent'">
														{{locale.translate('new_resource')}}
													</ng-container>
													<ng-container *ngIf="selectedContentType?.key === 'events'">
														{{locale.translate('new_event')}}
													</ng-container>
													<ng-container *ngIf="selectedContentType?.key === 'moocs'">
														{{locale.translate('new_mooc')}}
													</ng-container>
													<ng-container *ngIf="selectedContentType?.key === 'scorm'">
														{{locale.translate('new_scorm_package')}}
													</ng-container>
												</p>
											</div>
										</ng-container>
									</ng-container>
									<ng-container
										*ngFor="let resource of selectedResources; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let resourceIndex = index">

										<div class="updates-content fx-column fx-start-stretch">

											<div class="card-block fx-column fx-start-stretch">
												<ng-container *ngIf="!['playlist', 'answer','internalEvent','externalEvent'].includes(resource?.resourceTypeID?.key)">
													<app-content-image-card [record]="resource" [type]="'minimal'"
														(remove)="removeResource(resourceIndex)">
													</app-content-image-card>
													<!-- <mat-checkbox color="primary" [checked]="false">
																							<p class="caption">Agree test</p>
																						</mat-checkbox> -->
													<br />
												</ng-container>
												<ng-container *ngIf="resource.resourceFormat.key==='scorm'">
													<mat-checkbox class="chk-icon" [(ngModel)]="resource.includeScore">
														<span
															class="caption">{{locale.translate('assessment_integration_scorm')}}</span>
													</mat-checkbox>
												</ng-container>
												<ng-container *ngIf="resource?.resourceTypeID?.key === 'playlist'">
													<app-playlist-card [data]="resource" [type]="'minimal'"
														(remove)="removeResource(resourceIndex)">
													</app-playlist-card>
												</ng-container>
												<ng-container *ngIf="resource?.resourceTypeID?.key === 'answer'">
													<app-question-card [type]="'minimal'" [data]="resource"
														(remove)="removeResource(resourceIndex)">
													</app-question-card>
												</ng-container>
												<ng-container
													*ngIf="['internalEvent', 'externalEvent'].includes(resource?.resourceTypeID?.key)">
													<app-event-card [type]="'minimal'" [data]="resource"
														(remove)="removeResource(resourceIndex)">
													</app-event-card>
												</ng-container>
											</div>
										</div>

										<!-- <app-content-image-card [type]="'minimal'" [record]="resource"
																				(remove)="removeResource(resourceIndex)"></app-content-image-card> -->
										<!-- <div class="resource-search-card" fxLayout="row" fxLayoutAlign="start stretch">
									
																				<ng-container *ngIf="![null, undefined, ''].includes(resource.thumbnail)">
																					<div fxFlex="0 0 90px" class="resource-thumbnail">
																						<div class="thumbnail">
																							<img [src]="resource.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')">
																							<ng-container *ngIf="resource?.format">
																								<div class="img-overlay" fxLayout="row" fxLayoutAlign="center center">
																									<div class="format-icon" fxLayout="row" fxLayoutAlign="center center">
																										<ng-container *ngIf="resource?.format === 'video'">
																											<mat-icon svgIcon="video_camera">
																											</mat-icon>
																										</ng-container>
																										<ng-container *ngIf="resource?.format === 'audio'">
																											<mat-icon svgIcon="audio_headphone">
																											</mat-icon>
																										</ng-container>
																										<ng-container *ngIf="resource?.format === 'page'">
																											<mat-icon svgIcon="pages">
																											</mat-icon>
																										</ng-container>
																										<ng-container *ngIf="resource?.format === 'link'">
																											<mat-icon svgIcon="external_link">
																											</mat-icon>
																										</ng-container>
																										<ng-container *ngIf="resource?.format === 'document'">
																											<mat-icon svgIcon="document">
																											</mat-icon>
																										</ng-container>
																										<ng-container *ngIf="resource?.format === 'image'">
																											<mat-icon svgIcon="image_collection"></mat-icon>
																										</ng-container>
																									</div>
																								</div>
																							</ng-container>
																						</div>
																					</div>
																				</ng-container>
																				<div class="search-card-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
																					fxLayoutAlign="start stretch" fxLayoutGap="4px">
																					<div fxLayout="row" fxLayoutAlign="start start">
																						<div class="sub-txt-patch">
																							{{resource.type}}</div>
																					</div>
																					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
																						<p class="card-title" fxFlex="1 1" fxFlex.xs="auto">
																							{{resource.title}}</p>
																					</div>
																				</div>
									
																				<div class="resource-item-btn">
																					<button mat-icon-button (click)="removeResource(resourceIndex)">
																						<mat-icon>close
																						</mat-icon>
																					</button>
																				</div>
																			</div> -->
									</ng-container>


									<ng-container *ngIf="skillField?.length">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<div class="block-title"> {{ locale.translate('skills_covered') }} </div>
											<div fxLayout fxLayoutAlign="center start" class="form-container">
												<app-form-group [fieldList]="skillField"
													[formObjectData]="formObjectData" [config]="config"
													fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
													fxLayoutAlign.xs="start stretch" fxLayoutGap="0px"
													fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</ng-container>

									<ng-container *ngIf="preRequisiteField?.length">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<div class="block-title"> {{ locale.translate('prerequisite_skills') }}
											</div>
											<div fxLayout fxLayoutAlign="center start" class="form-container">
												<app-form-group [fieldList]="preRequisiteField"
													[formObjectData]="formObjectData" [config]="config"
													fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
													fxLayoutAlign.xs="start stretch" fxLayoutGap="0px"
													fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</ng-container>

									<app-alert id="courseAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center"
										fxLayoutGap="10px">

										<ng-container *ngIf="action === 'addModule'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('save')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'editModule'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('update')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'addActivity'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn" type="button">{{locale.translate('add')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'nominate' || action === 'enrollCourse'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button
												class="submit-btn"
												type="button">{{locale.translate('send_request')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
											class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'chooseContentType'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="content-type-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutAlign.xs="space-around stretch"
					fxLayoutGap="40px" fxLayoutGap.xs="0px">
					<ng-container *ngFor="let data of contentType; trackBy: gfService.trackByID.bind({'key': 'key'})">
						<div class="content-controls" fxLayout="column" fxLayoutAlign="start stretch"
							fxLayoutGap.xs="0px" (click)="openActivity(data)">
							<div class="control-item cursor-pointer" fxLayout="column" fxLayoutAlign="center center"
								fxLayoutGap="16px">
								<mat-icon class="control-icon" [svgIcon]="data.svgIcon"></mat-icon>
								<span class="caption">{{data.caption}}</span>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'generateCertificate' || action === 'viewCertificate'">
	<app-form-view [popup]="formPopup">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-course-card certificate-card" fxLayout="column" fxLayoutAlign="start stretch"
				fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="20px">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="22px">
							<div fxLayout="row" fxLayoutAlign="center center">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="42px">
									<ng-container *ngIf="info">
										<div class="form-info">
											<p class="caption-2">
												{{info}}
											</p>
										</div>
									</ng-container>
									<ng-container *ngIf="record?.certificateURL">
										<div class="certificate-view" fxLayout="column" fxLayoutAlign="start stretch">
											<img [src]="record?.certificateURL">
											<!-- <div class="certified-info" fxFlex="1 1" fxLayout="row" fxLayoutAlign="start start"
												fxLayoutGap="10px" fxLayoutAlign.xs="center center">
												<div
													[innerHtml]="locale.translate('this_is_to_certify_course_completion') | handleBar : {'userName': currentUser?.name, 'courseTitle': record?.title, 'date': certificationDate} | safeDom">

												</div>
											</div>
											<div fxLayout="row" fxLayoutAlign="space-between end">
												<p class="block-title">{{locale.translate('unidem')}}</p>
												<mat-icon class="logo-icon" svgIcon="bility_logo_tm"></mat-icon>
											</div> -->
										</div>
									</ng-container>
								</div>
							</div>
							<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
								<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-stroked-button
									class="close-btn">{{locale.translate('close')}}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>


<ng-container *ngIf="action === 'viewAssesmentResult'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area class="viewresult-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
			<app-profile-list-card [record]="userData" [assessmentScore]="scoredPercetageAssesment">
			</app-profile-list-card>
			<!-- <div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
				<div class="user-pic" fxFlex="0 0 40px">
					<ng-container *ngIf="![null, undefined, ''].includes(userData?.profilePicURL)">
						<img [src]="userData?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
					</ng-container>
					<ng-container *ngIf="[null, undefined, ''].includes(userData?.profilePicURL)">
						<img src="assets/img/man.png">
					</ng-container>
				</div>
				<div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
					fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<div class="user-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
						<span class="entity-title linkable">{{userData?.name}}</span>

					</div>

					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
						<ng-container
                                *ngIf="resourceDetail?.completedPercent >= 100 && resourceDetail?.scoredPercentage">
						<p class="score-dtls">32/100 (32)%
						</p>
						</ng-container>

					</div>
				</div>

			</div> -->
			<div class="question-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<ng-container>
					<app-common-list [layout]="'column'" [layoutGap]="'20px'">
						<list-item
							*ngFor="let question of testResultDetails; trackBy: gfService.trackByID.bind({'key': 'ID'});let i = index">
							<content-area fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
								<ng-container>
									<div class="tick-icon" *ngIf="question?.answer == question?.details.rightOption">
										<mat-icon svgIcon="tick_mark"></mat-icon>
									</div>
									<div class="warn-icon" *ngIf="question?.answer !== question?.details.rightOption">
										<mat-icon svgIcon="error"></mat-icon>
									</div>
								</ng-container>
								<div class="select-body fx-column fx-start-stretch">
									<div class="question-list fx-column fx-start-stretch">
										<div class="question-item fx-row fx-space-between-center">
											<ng-container *ngIf="![null,undefined].includes(question?.question)">
												<div class="question-content  fx-column fx-start-stretch fx-grow fx-shrink"
													[innerHtml]="question?.question | safeDom">
												</div>
											</ng-container>
										</div>
									</div>
								</div>
								<ng-container>
									<p class="entity-title">{{question.points}}pt
									</p>
								</ng-container>
							</content-area>
						</list-item>
					</app-common-list>
				</ng-container>
			</div>

		</content-area>
	</app-form-view>

</ng-container>

<ng-container *ngIf="action === 'viewScormReport'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area class="viewresult-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
			<!-- <ng-container *ngIf="scormReport">
				<app-profile-list-card [record]="userData" [scormData]="scormScore">
				</app-profile-list-card>
			</ng-container> -->
			<div class="enrollers" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
				<div class="user-pic" fxFlex="0 0 40px">
					<ng-container *ngIf="![null, undefined, ''].includes(userData?.profilePicURL)">
						<img [src]="userData?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')">
					</ng-container>
					<ng-container *ngIf="[null, undefined, ''].includes(userData?.profilePicURL)">
						<img src="assets/img/man.png">
					</ng-container>
				</div>
				<div class="cm-right-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
					fxLayoutGap="4px">
					<div class="user-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
						<span class="entity-title linkable">{{userData.name}}</span>
						<div class="user-info" fxLayoutGap="3px" fxLayoutGap.xs="1px">
							<ng-container *ngFor="let data of userData?.shortInfo; let isLast = last">
								<span class="sub-text-1">{{data.value}}</span>
								<ng-container *ngIf="!isLast">
									<span>|</span>
								</ng-container>
							</ng-container>
						</div>
					</div>
					<div class="overfiew" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
						
						<div class="tick-icon" >
							<mat-icon svgIcon="tick_mark"></mat-icon>
						</div>
						<span class="date-item"> {{ locale.translate('completed') }}</span>
						<ng-container *ngIf="![null, undefined, ''].includes(scormScore)">
							<span class="body-text">{{ locale.translate('score') }} : </span>
							<p class="score-dtls">{{scormScore}} %
							</p>
						</ng-container>
					</div>
				</div>
			</div>
			<ng-container *ngIf="scormReport">
				<app-table-chart class="table-chart" fxFlex="1 1 auto" [tableData]="scormReport"
					[barColor]="barColor" [tableOutlineColor]="tableOutlineColor"></app-table-chart>
			</ng-container>
		</content-area>
	</app-form-view>
</ng-container>
